module.exports = __webpack_public_path__ + "static/img/new11-Vt2Uq7Jd.0fbd26c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new11-Vt2Uq7Jd.png
// module id = aQqW
// module chunks = 16